import { maskCpf } from "../../../utils/masks";
import { Button } from "../../Atoms/Button";
import { Eye } from "../../Atoms/Eye";
import { Input } from "../../Atoms/Inputs/Input";
import { Pagination } from "../../Atoms/Pagination";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useCollaborators } from "./useCollaborators";

export const CollaboratorsTemplate = () => {
  const {
    setIsOpen,
    isOpen,
    pagination,
    setNumberPage,
    isMobile,
    colaboradores,
    navigate,
    handleFilter,
    handleReset,
    handleSubmit,
    register,
    canAccessEmployees,
    canEditEmployees,
  } = useCollaborators();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Colaboradores Cadastradas</Title>

        <S.WrapperButtons>
          <Button
            data-variant-outline
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img src="/assets/svgs/icon-filter-dark.svg" alt="icone filter" />
            Filtrar
          </Button>
          <Button
            data-variant-outline
            onClick={() => navigate("/configuracoes/colaboradores/cadastro")}
          >
            <img src="/assets/svgs/icon-plus.svg" alt="icone plus" />
            Cadastrar
          </Button>
        </S.WrapperButtons>

        {isOpen && (
          <S.Filter onSubmit={handleSubmit(handleFilter)}>
            <div>
              <Input id="name" {...register("nome")} label="Nome" />
            </div>
            <div>
              <Input id="cpf" {...register("cpf")} label="CPF" maxLength={14} />
            </div>
            <div>
              <Button data-variant-text type="button" onClick={handleReset}>
                Limpar tudo
              </Button>
              <Button>Buscar</Button>
            </div>
          </S.Filter>
        )}

        {canAccessEmployees && colaboradores?.length > 0 && (
          <S.Table>
            {colaboradores.map((i) => (
              <S.TableItem key={`${Math.random()}`}>
                <p>
                  NOME: <span>{i.nome}</span>
                </p>
                <p>
                  CPF: <span>{maskCpf(i.cpf)}</span>
                </p>

                <div>
                  {canEditEmployees ? (
                    <Eye
                      onClick={() =>
                        navigate(
                          `/configuracoes/colaboradores/detalhe?id=${i.uuid}`
                        )
                      }
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </S.TableItem>
            ))}
          </S.Table>
        )}

        {canAccessEmployees && colaboradores?.length > 0 && (
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination.totalPage}
            totalRegister={pagination.totalPage}
            actualPage={pagination.actualPage}
            setNumberPage={setNumberPage}
          />
        )}
      </S.Wrapper>
    </S.Container>
  );
};
